import { useDispatch } from "react-redux";
import Layout from "./Layout";
import TitleZ from "../ui/atoms/TitleZ";
import Buttonz from "../ui/atoms/Buttonz";
import ValidationAlertsGallery from "../ui/dev/ValidationAlertsGallery";
import { VALIDATION_ALERT_VARIANTS } from "../data/validationAlertVariants";
import { validationPopup } from "../redux/actions";
import "../styles/main.scss";
import "../styles/compo.scss";
import "../styles/vars.scss";

export default function AlertStyleLab() {
  const dispatch = useDispatch();

  return (
    <Layout>
      <div className="alert-style-lab-page">
        <div className="alert-style-lab-page__header">
          <TitleZ
            title="Alert style lab"
            text={
              <>
                Static previews below match production toast markup. Use them to
                tune <code className="alert-style-lab__code">atoms.scss</code> (
                <code className="alert-style-lab__code">.tooltip</code>
                ). Live triggers fire the real Redux flow (they hide after a few
                seconds).
              </>
            }
          />
        </div>

        <ValidationAlertsGallery />

        <section className="alert-style-lab-page__live" aria-label="Live toasts">
          <h2 className="alert-style-lab-page__h2">Live toasts (auto-dismiss)</h2>
          <p className="alert-style-lab-page__live-hint">
            Same as in the app: fixed to top, ~5s visible.
          </p>
          <div className="alert-style-lab-page__buttons">
            {VALIDATION_ALERT_VARIANTS.map((v) => (
              <Buttonz
                key={v.key}
                label={`${v.type}${v.icon ? ` · ${v.icon}` : ""}`}
                className="secondary lined"
                onClick={() =>
                  dispatch(
                    validationPopup({
                      message: v.message,
                      icon: v.icon || undefined,
                      type: v.type,
                    })
                  )
                }
              />
            ))}
          </div>
        </section>
      </div>
    </Layout>
  );
}
